/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { trackCaptureEvent } from "@eisinc/App/CoveoConnector/Services/CoveoService";
import { getCoveoSettingsCollection } from "@eisinc/App/CoveoConnector/Store/Selectors/SettingsSelectors";
import { CaptureEventRequest } from "@eisinc/App/CoveoConnector/Types/schema";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";

export const XngCoveoRemoveProductFromCart: any = (props: any) => {
    const state = props.getState();
    const isConfiguredForCoveo = getCoveoSettingsCollection(state).coveoSettings.isConfiguredForCoveo;
    const session = getSession(props.getState());

    if (isConfiguredForCoveo) {
        if (!window) {
            return;
        }

        const cart = getCurrentCartState(props.getState()).value;
        if (cart?.cartLines?.length) {
            const removedCartLineItem = cart.cartLines.find(c => c.id === props.apiParameter.cartLineId) as any;

            if (removedCartLineItem) {
                const targetProduct = removedCartLineItem as any;
                const isVariantProduct = targetProduct.properties?.isVariantProduct?.toLowerCase() === "true";

                const captureEventParameter: CaptureEventRequest = {
                    pageUrl: window.location.href,
                    eventName: "remove",
                    searchHub: "listing",
                    products: [{
                        productId: isVariantProduct ? targetProduct.properties.parentProductId : targetProduct.productId,
                        productName: isVariantProduct ? targetProduct.properties.parentProductShortDescription : targetProduct.shortDescription,
                        price: targetProduct.pricing?.unitListPrice,
                        brand: targetProduct.brand?.name as string,
                        currencyCode: session.currency?.currencyCode,
                        quantity: targetProduct.qtyOrdered,
                        variantErpNumber: isVariantProduct ? targetProduct.erpNumber : null,
                    }],
                };
                trackCaptureEvent(captureEventParameter);
            }
        }
    }
};

const _CoveoRemoveProductFromCart = XngCoveoRemoveProductFromCart as any;

addToEndOfChain(chain, _CoveoRemoveProductFromCart);
